import { useEffect, useRef, useState } from 'react';
import './PrettySelect.css';

export default function PrettySelect({ value, options, onChange, icon, className = '' }) {
  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);
  const selectedOption = options.find((option) => {
    const optionValue = typeof option === 'string' ? option : option.value;
    return optionValue === value;
  });
  const selectedLabel = typeof selectedOption === 'string'
    ? selectedOption
    : selectedOption?.label ?? value;

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleSelect = (nextValue) => {
    onChange(nextValue);
    setOpen(false);
  };

  return (
    <div className={`pretty-select ${className}${open ? ' is-open' : ''}`} ref={selectRef}>
      <button
        type="button"
        className="pretty-select-trigger"
        onClick={() => setOpen((current) => !current)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {icon && <span className="pretty-select-icon">{icon}</span>}
        <span className="pretty-select-value">{selectedLabel}</span>
        <span className="pretty-select-chevron" aria-hidden="true">
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M1 1L6 6L11 1" stroke="#505F76" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>

      {open && (
        <div className="pretty-select-menu" role="listbox">
          {options.map((option) => {
            const optionValue = typeof option === 'string' ? option : option.value;
            const optionLabel = typeof option === 'string' ? option : option.label;
            const selected = optionValue === value;

            return (
              <button
                type="button"
                key={optionValue}
                className={`pretty-select-option${selected ? ' is-selected' : ''}`}
                onClick={() => handleSelect(optionValue)}
                role="option"
                aria-selected={selected}
              >
                <span>{optionLabel}</span>
                {selected && (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M3.5 8.2L6.4 11L12.5 5" stroke="#4683E5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
